var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 41,
    viewBox: "0 0 37 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1329 21.316C30.1949 27.3876 36.0158 29.4084 36.08 29.4342C36.0308 29.5763 35.1502 32.3137 33.0137 35.1406C31.1669 37.5848 29.2498 40.0199 26.2305 40.0709C23.2638 40.12 22.3097 38.4774 18.9174 38.4774C15.5261 38.4774 14.4665 40.0199 11.6577 40.12C8.74298 40.2201 6.52342 37.4766 4.66125 35.0418C0.856284 30.0604 -2.05165 20.9656 1.85282 14.8264C3.7924 11.7777 7.25923 9.84736 11.0218 9.79763C13.8837 9.74821 16.5851 11.541 18.3346 11.541C20.083 11.541 23.3658 9.38488 26.8169 9.70139C28.2618 9.75597 32.3171 10.2297 34.9212 13.6815C34.7118 13.7994 30.0826 16.2397 30.1329 21.316ZM24.557 6.40623C26.1043 4.71037 27.1458 2.34889 26.8618 0C24.6312 0.0810629 21.9341 1.34577 20.3344 3.04099C18.9006 4.54178 17.6451 6.9446 17.9836 9.24698C20.47 9.42138 23.0095 8.10306 24.557 6.40623Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosIcon);
export default __webpack_public_path__ + "static/media/iosIcon.456a6976ebcb697e23e480c56eb22caa.svg";
export { ForwardRef as ReactComponent };